/* src/app/home-new/home-main-content-section/upload-files-options/upload-files-options.component.scss */
#fileDropRef {
  opacity: 0;
  width: 0;
  cursor: pointer;
}
.upload-buttons {
  position: relative;
}
.upload-files-button {
  font-weight: 600;
  font-size: 18px;
  height: 100%;
  min-height: unset;
}
.upload-files-button ion-icon {
  margin-right: 10px;
  font-size: 22px;
}
@media (max-width: 1280px) {
  input {
    max-width: 160px;
  }
}
.drive-button,
.dropbox-button {
  height: 100%;
  transition: all 0.5s ease;
}
.drive-button ion-icon,
.dropbox-button ion-icon {
  font-size: 38px;
}
.drive-button:hover,
.dropbox-button:hover {
  transform: scale(1.2);
  transition: all 0.5s ease;
}
.drive-button:hover::part(native),
.dropbox-button:hover::part(native) {
  --border-radius: 100%;
  transition: all 0.5s ease;
  aspect-ratio: 1/1;
}
.drive-button::part(native),
.dropbox-button::part(native) {
  padding: 0;
  transition: all 0.5s ease;
  aspect-ratio: 1/1;
  background: transparent;
}
.drag-files-caption {
  display: flex;
  justify-content: center;
  color: var(--ion-color-primary);
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
}
.dragging-notification {
  position: fixed;
  left: var(--main-content-left, 0px);
  right: var(--main-content-right, 0px);
  bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  transform: translateY(300px);
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  z-index: 9;
}
.dragging-notification.visible {
  transform: translateY(0);
}
.dragging-notification ng-lottie {
  width: 200px;
  margin: auto;
  transform: translateY(90px);
}
.dragging-notification div {
  background: var(--ion-color-primary);
  padding: 20px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-family: "Barlow Semi Condensed", sans-serif;
  border-radius: 30px;
  font-size: 20px;
  font-weight: 500;
}
@media (max-width: 1280px) {
  .upload-files-button {
    font-size: 16px;
  }
  .drive-button,
  .dropbox-button {
    height: 35px;
    min-height: unset;
  }
  .drive-button ion-icon,
  .dropbox-button ion-icon {
    font-size: 35px;
  }
}
@media (max-width: 1104px) {
  .upload-files-button {
    width: 100%;
  }
}
/*# sourceMappingURL=upload-files-options.component-YOQIRNRM.css.map */
